export default "__VITE_ASSET__DIJmG1C6__"